const thanhToanReducer = (state = { products: [] }, action) => {
    switch (action.type) {
        case "GET_ALL_THANHTOAN_PRODUCT":
            return state;
        case "SET_THANHTOAN_PRODUCT":
            return {
                ...state,
                products: action.products
            };
        case "REMOVE_ALL_FROM_THANHTOAN_PRODUCT":
            return {
                ...state,
                products: []
            };
        case "UPDATE_THANHTOAN_PRODUCT":
            const updatedProducts = [...state.products];
            const updatedProduct = action.product;
            const productLastestUpdateToUpdate = updatedProduct.last_modified;
            // Find the index of the product with the matching productId
            const indexToUpdate = updatedProducts.findIndex(
                (product) => product.last_modified === productLastestUpdateToUpdate
            );
            if (indexToUpdate !== -1) {
                // If the product with the matching productId is found, update it
                updatedProducts[indexToUpdate] = updatedProduct;
            }

            return {    
                ...state,
                products: updatedProducts,
            };
            
        case "ADD_NEW_PRODUCT":
            const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
            const newProduct = {
                ...action.product,
                orderTime: currentTime
            };
            return {
                ...state,
                products: state.products ? [...state.products, newProduct] : [newProduct]
            };
        case "REMOVE_FROM_THANHTOAN_PRODUCT":
            const indexToRemove = action.index;
            return {
                ...state,
                products: state.products.filter((product, index) => index !== indexToRemove)
            };
        default:
            return state;
    }
};

export default thanhToanReducer;
